function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
import React from 'react';
import PropTypes from 'prop-types';
import APSelect from '../common/APSelect';
import config from '../../config';
import { getGateway } from '../../helpers/wsHelper';
import { changeServer } from '../../redux/actions/wsConnectionActions';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import './TradingServerComponent.css';
var baseClasses = getBEMClasses('trading-server');
var TradingServer = function TradingServer(props, context) {
  var currentServer = getGateway(config.global.gateway);
  var tradingServers = config.global.gateway.filter(function (item) {
    return item !== currentServer;
  }).map(function (item) {
    return {
      value: item,
      label: item
    };
  });
  return React.createElement(APSelect, {
    name: 'gateway',
    label: context.t('Select server') + ':',
    showTriangles: true,
    customClass: baseClasses(),
    onSelect: function onSelect(value) {
      return changeServer(value);
    },
    options: [{
      value: currentServer,
      label: currentServer
    }, {
      value: 'CUSTOM',
      label: 'Custom server ...'
    }].concat(_toConsumableArray(tradingServers))
  });
};
TradingServer.contextTypes = {
  t: PropTypes.func.isRequired
};
export default TradingServer;